import React, { Component } from 'react';

class Terms extends Component {
    constructor(props) {
        super(props);
        this.go2Booking = this.go2Booking.bind(this);
        this.state = {}
    }
    go2Booking(e) {
        this.props.history.push('/page/appointment/');
    }
    render() {

        return (
            <div className="page">

                <div className="row" style={{ marginTop: '10px', marginRight: '0px', marginLeft: '0px' }}>
                    <div className="col-md-3 col-lg-3 col-sm-2"></div>
                    <div className="col-md-6 col-lg-6 col-sm-8 main-div">
                        <div className="terms-head">
                        Terms & Conditions for Facility Appointment at Maybank Group Locations
                        </div>
                        <div style={{ paddingBottom: '10px', fontSize: '15px' }}>
                        These terms and conditions will govern the information you submit via this Facility Appointment.
                        </div>
                        <div className="row">
                            <div className="col-md-1 col-sm-1 col-xs-1" style={{ paddingRight: '0px' }}>1.</div>
                            <div className="col-md-11 col-sm-11 col-xs-11" style={{ paddingLeft: '5px' }}>
                            All information submitted by you will be subject to the
                            <a target="_blank" rel={'noopener noreferrer'}
                               href="https://www.maybank2u.com.my/mbb_info/m2u/public/personalDetail04.do?cntTypeId=0&cntKey=SEC02&chCatId=/mbb/Personal&programId=FO-Footer">Maybank Group's Privacy Notice</a>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-1 col-sm-1 col-xs-1" style={{ paddingRight: '0px' }}>2.</div>
                            <div className="col-md-11 col-sm-11 col-xs-11" style={{ paddingLeft: '5px' }}>
                            In line with the government initiative on Covid-19, all information collected via this Contact Tracing Register will be used for the purpose of curbing the spread of Facility Appointment and may be shared with any governmental authorities or third parties in accordance with our Privacy Notice.
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-1 col-sm-1 col-xs-1" style={{ paddingRight: '0px' }}>3.</div>
                            <div className="col-md-11 col-sm-11 col-xs-11" style={{ paddingLeft: '5px' }}>
                            You confirm that all information provided by you is accurate and up to date at the point of submission.
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-1 col-sm-1 col-xs-1" style={{ paddingRight: '0px' }}>4.</div>
                            <div className="col-md-11 col-sm-11 col-xs-11" style={{ paddingLeft: '5px' }}>
                            Maybank Group will not be held liable for any direct or indirect loss or damages sustained by you due to the usage of this Facility Appointment unless it is due to gross negligence, fraud or wilful misconduct on our part.
                            </div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <input type="button" value="I Understand" className="btnLogin" onClick={this.go2Booking} />
                        </div>
                    </div>
                    <div className="col-md-3 col-lg-3 col-sm-2"></div>
                </div>
            </div>
        )
    }
}
export default Terms;
